import './dashboard_results_view.js.coffee'

Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.DashboardQueryView extends Monitoring.Views.DashboardResultsView
  template: JST["backbone/templates/monitoring/dashboard_query"]
  defaultSearchMethod: 'search'

  initialize: (options) ->
    super(options)
    @vueSocialContentsAnalysisButtonComponent = new VueInBackbone.VueComponent('social-contents-analysis-button', { exploreToolbar: true, theme: 'blue' })

  events: =>
    return _.extend({}, Monitoring.Views.DashboardResultsView.prototype.events, {
      'change .order-by': 'onChangeOrderField'
      'click .order-direction': 'onToggleOrderDirection'
      'click #next_social_contents_btn': 'next'
    })

  render: ->
    super()
    $('.monitoring-dashboard').addClass('explore').removeClass('review')

    if @options.submodesPermissions && @options.submodesPermissions.social_contents_analysis
      @renderSocialContentsAnalysisButton()

    @

  renderSocialContentsAnalysisButton: ->
    @$el.find('.view-selection__social-contents-analysis-button').append(@vueSocialContentsAnalysisButtonComponent.el)
    @vueSocialContentsAnalysisButtonComponent.render()
    @vueSocialContentsAnalysisButtonComponent.on('click', @showSocialContentsAnalysis)

  showSocialContentsAnalysis: =>
    @trigger('showSocialContentsAnalysis')

  onChangeOrderField: (event) ->
    orderField = event.target.value
    @searchQuery.setOrderField(orderField)
    @_refresh()

  onToggleOrderDirection: ->
    orderDirection = if @searchQuery.get('order').direction == 'desc' then 'asc' else 'desc'
    @searchQuery.setOrderDirection(orderDirection)
    @$el.find('button.order-direction i').removeClass().addClass("fa fa-sort-amount-#{orderDirection}")
    @_refresh()

  next: (event) =>
    return if $(event.target).is('select') || $(event.target).is('option') # Hack in order to prevent select box to trigger onClick event!
    @$el.find('#previous_results_link').addClass('processing')
    @searchQuery.next(parseInt(@$el.find('#number_of_results').val()))
    @searchWith('next', false)

  fetchNewResults: ->
    @$el.find('#new_content_available').addClass('processing')
    @searchWith('realtime', false, @handleRealtimeResults)

  handleQueryResults: (dashboardResults, new_search) =>
    @$el.find('#previous_results_link').removeClass('processing')
    super(dashboardResults, new_search)

  handleRealtimeResults: (dashboardResults) =>
    @realtimeContentCheckerView.hide()
    @$el.find('#new_content_available').removeClass('processing')
    _.each(dashboardResults.values, (content) => @addOneToTheBegining(content, Keepcon.tags))
    @updateResultCount(dashboardResults.values.length)
    @trigger('searchCompleted', {})

  addOneToTheBegining: (socialContent, allTags) =>
    @addOne(socialContent, allTags, (element) =>
      @$resultsContainer.prepend(element))

  addOne: (socialContent, allTags, addFunction) =>
    view = Monitoring.Views.SocialContentViewFactory.create(socialContent, allTags, @currentUser, @accountSettings, @customerData, @searchQuery.defaultChartsByAccount)
    @addAndApplyEffect(view, addFunction) if view

  destroy: ->
    @vueSocialContentsAnalysisButtonComponent.remove()
    super()
